// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/time-speed-distance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/time-speed-distance/tsd-eta.js';
import g1 from '../lessons/navigation/time-speed-distance/tsd-groundspeed.js';

mount([g0, g1]);
